define('v3/Common/Components/NavBackButton/NavBackButton.Component',[
	'knockout',
	'v3/Common/Services/pageStateService',
	'text!v3/Common/Components/NavBackbutton/NavBackbutton.Component.html'
], function (ko, pageStateService, htmlString) {
	function validateParams (params) {
		if (!params.navBackButtonParams) {
			throw new Error('params.navBackButtonParams is expected.');
		}
	}

	function NavBackButtonViewModel (params) {
		var self = this;
		validateParams(params);

		self.makeComputedByTemplate = function (template) {
			if (!template) {
				return null;
			}

			var templateObservable = ko.isObservable(template) ? template : ko.observable(template);

			return ko.computed(function () {
				var templateValue = templateObservable();

				if (!templateValue) {
					return null;
				}

				return templateValue.replace(/{[^}]*}/g, function (paramName) {
					var observable = pageStateService.getStringObservable(paramName.substring(1, paramName.length - 1));
					return observable();
				});
			});
		};

		self.name = self.makeComputedByTemplate(params.navBackButtonParams.name);
		self.link = self.makeComputedByTemplate(params.navBackButtonParams.linkTemplate);

		self.gotoLink = function () {
			if (params.navBackButtonParams.linkTemplate) {
				window.location = self.link();
			}
			if (params.navBackButtonParams.linkFunction) {
				params.navBackButtonParams.linkFunction();
			}
		};
	}

	return { viewModel: NavBackButtonViewModel, template: htmlString };
});
